import Vue from 'vue';
import Component from 'vue-class-component';
import MeasureUnitsSettingsView from "@/views/settings/measure-unit/MeasureUnitsSettingsView";
import DimensionsSettingsView from "@/views/settings/dimension/DimensionsSettingsView";
import CommunicationSettingsView from "@/views/settings/communication/CommunicationSettingsView";
import CustomArticleFieldsView from "@/views/settings/article-fields/CustomArticleFieldsView";
import WebServicesSettingsView from "@/views/settings/web-services/WebServicesSettingsView";
import ExportSettingsView from "@/views/settings/export/ExportSettingsView";
import ScaleView from "@/views/settings/scale/ScaleView";
import CameraSettingsView from "@/views/settings/camera/CameraSettingsView";
import JdbcSettingView from "@/views/settings/jdbc/JdbcSettingView";

@Component({
  components: {
    JdbcSettingView,
    Scale: ScaleView,
    CameraSettingsView,
    WebServicesSettingsView,
    ExportSettingsView,
    CustomArticleFieldsView,
    CommunicationSettingsView,
    DimensionsSettingsView,
    MeasureUnitsView: MeasureUnitsSettingsView
  }
})
export default class Settings extends Vue {
  public tabs: any = null;
}
